import React from "react";
import { Container, Row, Col } from "reactstrap";
import SteeringOverviewBlock from "../components/SteeringOverviewBlock";
import SiteOverviewBlock from "../components/SiteOverviewBlock";
import ContactUsBlock from "../components/ContactUsBlock";
import PerformanceOverviewBlock from "../components/PerformanceOverviewBlock";
import { useAppData } from "../context";

const Live = () => {
    const data = useAppData();

    if (!data?.customer) {
        return (
            <div className="d-flex justify-content-center align-items-center vh-100">
                <div className="card bg-info text-white shadow-lg p-4">
                    <div className="card-body text-center">
                        <h5 className="card-title mb-3">Account Not Found</h5>
                        <p className="card-text">
                            We did not find your Customer account,<br />
                            please contact our Support Team (aka Nathan)
                        </p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <Container className="mb-2 mb-md-5 px-1 px-md-3">
            <h4 className="mb-2  text-muted text-left"><strong>{data.customer.display_name}</strong></h4>
            <Row style={{ marginInline: 0 }}>
                {data.sites.slice().sort((a, b) => a.id.localeCompare(b.id)).map((site, index) => {

                    const selectedPreference = data.steering_preferences?.find(
                        (p) => p.id === site.active_steering_mode
                    );
                    const availablePreferences = data.steering_preferences?.filter(
                        (p) => p.site_id === site.id
                    );
                    const optiPreferenceExists = data.steering_preferences?.some(
                        (p) => p.site_id === site.id && p.preference_type === "Optischedule"
                    );

                    return (
                        <Col key={index} md={10} className="mb-5" style={{ paddingInline: 0 }}>
                            <SteeringOverviewBlock
                                key={index + "SteeringOverview"}
                                siteId={site.id}
                                preferences={availablePreferences}
                                preferenceType={selectedPreference?.preference_type}
                                optiPreferenceExists={optiPreferenceExists}
                            />
                            <PerformanceOverviewBlock
                                key={index + "PerformanceOverview"}
                                site={site}
                                userTimezone={data.user.timezone}
                            />
                            <ContactUsBlock
                                key={index + "ContactUs"}
                            />
                            <SiteOverviewBlock
                                key={index + "SiteOverview"}
                                siteId={site.id}
                            />
                        </Col>
                    );
                })}
            </Row>
        </Container>
    );
};

export default Live;
